import React, { useEffect, useState } from "react";
import { RajProcurementRecord } from "../../../models/rajasthan";
import { setTableData } from "../../../store/state/Discom/Discom";
import PaginationTable from "../../../components/Table";
import { ReactComponent as Edit } from "../../../icons/edit.svg";
import "./RajProcurementTable.css";
import { Pagination } from "../../../components/Pagination";
import FilterModal from "../../../Popup/FilterModal";
import axios from "axios";

const ITEMS_PER_PAGE = 17;

const RajProcurementTable = () => {
  localStorage.removeItem("procurement_edit_id");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalList, setTotalList] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [filterModal, setFilterModal] = useState(true);
  const [filterData, setFilterData] = useState("");
  console.log(filterData);
  const totalPages = Math.ceil(totalList / ITEMS_PER_PAGE);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    if (filterData) {
      handleFilterPage();
    } else {
      handleFetchData();
    }
  }, [currentPage]);

  const handleFilterPage = async () => {
    let payload = {
      page: currentPage,
      per_page: 50,
      filter: filterData,
    };

    const data = await axios.post(
      "https://datahub.gna.energy/rajasthan_procurement",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (data?.data?.total > 0) {
      setTableData(data?.data?.data);
      setTotalList(data?.data?.total);
    }
  };

  async function handleFetchData() {
    try {
      const response = await fetch(
        `https://datahub.gna.energy/rajasthan_procurement?page=${currentPage}&per_page=${ITEMS_PER_PAGE}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setTableData(data?.data);
      setTotalList(data?.total);
    } catch (error) {
      console.error("Error fetching Procurement Record :", error);
      return [];
    }
  }

  const handleEdit = (data) => {
    localStorage.setItem("procurement_edit_id", data?.id);
    handleTabChange("Form");
  };

  const handleTabChange = (option) => {
    const url = new URL(window.location.href);
    url.searchParams.set("tab", option);
    window.history.pushState({}, "", url);
    window.location.reload();
  };

  const handleFilterClick = () => {
    if (filterData) {
      handleFetchData();
      setFilterData("");
    } else {
      setIsFilterOpen((prev) => !prev);
    }
  };

  const handleCloseFilter = (event) => {
    if (event.target.id === "filter-modal-overlay") {
      setIsFilterOpen(false);
    }
  };

  return (
    <div className="page-container">
      {isFilterOpen && (
        <div id="filter-modal-overlay" onClick={handleCloseFilter}>
          <div>
            <FilterModal
              open={isFilterOpen}
              handleClose={() => setIsFilterOpen(false)}
              setTotalList={setTotalList}
              setTableData={setTableData}
              setFilterData={setFilterData}
            />
          </div>
        </div>
      )}
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th className="rajtable-filter-cell" onClick={handleFilterClick}>
                {filterData ? "Clear Filter" : "Filter"}
              </th>

              {/* <th className="rajtable-cell">Edit</th> */}
              <th className="rajtable-cell">Date of Transaction</th>
              <th className="rajtable-cell">Type Of Transaction</th>
              {/* <th className="rajtable-cell">Application No.</th> */}
              <th className="rajtable-cell">Purchase through / Product</th>
              <th className="rajtable-cell">Platform</th>
              <th className="rajtable-cell">Tender No.</th>
              <th className="rajtable-cell">Trader/Bidder</th>
              <th className="rajtable-cell">
                Name of Counterparty / Generator
              </th>

              {/* drawl */}
              <th className="rajtable-cell">Drawl_From Date</th>
              <th className="rajtable-cell">Drawl_To Date</th>
              <th className="rajtable-cell">Drawl_From Time</th>
              <th className="rajtable-cell">Drawl_To Time</th>
              <th className="rajtable-cell">Drawl_MW</th>
              <th className="rajtable-cell">Drawl_Total Lu</th>

              <th className="rajtable-cell">Rate(₹) / kwh</th>
              <th className="rajtable-cell">Banking Factor (%)</th>
              <th className="rajtable-cell">Amount(Cr) per Day</th>

              {/* Inject */}
              <th className="rajtable-cell">Inject_From Date</th>
              <th className="rajtable-cell">Inject_To Date</th>
              <th className="rajtable-cell">Inject_From Time</th>
              <th className="rajtable-cell">Inject_To Time</th>
              <th className="rajtable-cell">Inject_MW</th>
              <th className="rajtable-cell">Inject_Total Lu</th>

              <th className="rajtable-cell">Approval ID/ Agreement ID</th>
              <th className="rajtable-cell">PPA Date/ Agreement Date</th>
              <th className="rajtable-cell">LOI Date</th>
              <th className="rajtable-cell">LOI No.</th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((ele) => (
              <tr>
                <td onClick={() => handleEdit(ele)}>
                  <Edit />
                </td>
                <td>{""}</td>
                {/* <td>{ele?.application_no}</td> */}
                <td>{ele?.type_of_transaction}</td>
                <td>{ele?.purchase_through_product}</td>
                <td>{ele?.platform}</td>
                <td>{ele?.tender_no}</td>
                <td>{ele?.trader_bidder}</td>
                <td>{ele?.name_of_counterparty_generator}</td>
                <td>{ele?.drawal_purchase_import_date_from}</td>
                <td>{ele?.drawal_purchase_import_date_to}</td>
                <td>{ele?.drawal_purchase_import_time_from}</td>
                <td>{ele?.drawal_purchase_import_time_to}</td>
                <td>{ele?.drawal_purchase_import_mw}</td>
                <td>{ele?.drawal_purchase_import_lu}</td>
                <td>{ele?.rate}</td>
                <td>{ele?.banking_factor}</td>
                <td>{ele?.amount_cr_per_day}</td>
                <td>{ele?.inject_sell_export_date_from}</td>
                <td>{ele?.inject_sell_export_date_to}</td>
                <td>{ele?.inject_sell_export_time_from}</td>
                <td>{ele?.inject_sell_export_time_to}</td>
                <td>{ele?.inject_sell_export_mw}</td>
                <td>{ele?.inject_sell_export_lu}</td>
                <td>{ele?.approval_id_agreement_id}</td>
                <td>{ele?.ppa_date_agreement_date_loi_date}</td>
                <td>{ele?.loi_date}</td>
                <td>{ele?.loi_number}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={currentPage}
        totalItems={totalList}
        itemsPerPage={ITEMS_PER_PAGE}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default RajProcurementTable;
